var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5618 41.7505C14.9248 43.0603 12.5 41.8948 12.5 39.7985V20.2016C12.5 18.1053 14.9248 16.9399 16.5618 18.2494L28.8098 28.0478C30.0608 29.0488 30.0608 30.9513 28.8098 31.9523L16.5618 41.7505Z",
    stroke: "#F7991E",
    strokeWidth: 4.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5617 41.7505C34.9247 43.0603 32.5 41.8948 32.5 39.7985V20.2016C32.5 18.1053 34.9247 16.9399 36.5617 18.2494L48.8097 28.0478C50.0607 29.0488 50.0607 30.9513 48.8097 31.9523L36.5617 41.7505Z",
    stroke: "#F7991E",
    strokeWidth: 4.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForward);
export default __webpack_public_path__ + "static/media/fast-forward.abd76238e959f44268f480068d499f90.svg";
export { ForwardRef as ReactComponent };